import {Link} from '@primer/react'

const allowedUrlHosts = ['platform.openai.com']
const urlRegex = /(https?:\/\/[^\s]+)/g

function isAllowedUrl(text: string) {
  if (!urlRegex.test(text)) return false

  try {
    const url = new URL(text, window.location.origin)
    return allowedUrlHosts.includes(url.hostname)
  } catch {
    return false
  }
}

export function LinkifyErrorMessage({message}: {message: string}) {
  return (
    <>
      {message.split(urlRegex).map(part =>
        isAllowedUrl(part) ? (
          <Link key={part} href={part} inline rel="noopener noreferrer">
            {part}
          </Link>
        ) : part.trim().length > 0 ? (
          <span key={part}>{part}</span>
        ) : null,
      )}
    </>
  )
}

try{ LinkifyErrorMessage.displayName ||= 'LinkifyErrorMessage' } catch {}